module.exports = __webpack_public_path__ + "media/images/level_introduction_header_sp-8f532c1a12f89a782932c23b9d373b51.png";